import axios from '@/libs/api.request'
const login = {
    // 登录
    login: (data) => {
        return axios.post({
            url: '/Login',
            data: data
        })
    },
    // 登录
    loginOut: () => {
        // return axios.post({
        //     url: '/loginOut'
        // })
    }
}
export default login


// WEBPACK FOOTER //
// ./src/api/api-login.js